//Full registration page, using Register.js.
import React from 'react';
import Register from '../components/Register'; // Import the reusable Register component
import '../App.css'; // Import external CSS file for styling

function RegisterPage() {
    return (
        <div className="register-page">
            <h1>Создать учетную запись</h1>
            <p>Заполните форму ниже:</p>
            <Register /> {/* Embed the reusable Register component */}
        </div>
    );
}

export default RegisterPage;
